import { ComponentProps } from 'react'
import { OfferPriceController } from './OfferPrice.controller'
import { useTenant } from 'core/logic/tenant/tenant.hook'

export default function OfferPriceLogic(
  props: Omit<ComponentProps<typeof OfferPriceController>, 'acceptedCurrencies'>
) {
  const { tenant } = useTenant()
  return (
    <OfferPriceController
      {...props}
      acceptedCurrencies={tenant?.currencies?.accepted}
    />
  )
}
